import { makeStyles, Theme } from '@material-ui/core/styles';
import { purple, white } from 'globals/colors';

export const useStyles = makeStyles(({ spacing, typography }: Theme) => ({
  ul: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
    display: 'flex',
  },
  prevNextItem: {},
  li: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: spacing(0, 0.5),
  },
  defaultItem: {
    fontFamily: typography.fontFamily,
    height: 30,
    background: white,
    borderRadius: 5,
    border: 0,
    boxShadow:
      '0px 4px 7px rgba(112, 56, 167, 0.1), 0px 3px 7px rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': { background: purple.V5 },
    '&:active': { background: purple.V3 },
    '&:focus': { outline: 'none' },
  },
  selectedItem: {
    background: `${purple.BRAND}!important`,
    color: white,
    fontWeight: typography.fontWeightBold,
    border: '0!important',
  },
  pageItem: {
    width: 30,
  },
}));
